import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../../actions/authentication';
import { EmptyList } from '../../../components/SavedSearches/EmptyList';
import { selectUser } from '../../../selectors';

export const EmptyListContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(selectUser);

  const handleSearchClick = React.useCallback(() => {
    if (isAuthenticated) {
      window.location.href = 'https://cian.ru/';
    } else {
      dispatch(requestAuthentication());
    }
  }, [dispatch, isAuthenticated]);

  return <EmptyList isAuthenticated={isAuthenticated} onClick={handleSearchClick} />;
};
